





















































































































































































































import SeletorDeFornecedor from '@/components/fornecedor/SeletorDeFornecedor.vue';
import SeletorDeLojas from '@/components/loja/SeletorDeLojas.vue';
import SeletorDeProdutosAgrupados from '@/components/produto/SeletorDeProdutosAgrupados.vue';
import { Fornecedor, Loja, ProdutoBase, ProdutoDoFornecedor } from '@/models';
import AlertModule from '@/store/vuex/aplicacao/AlertModule';
import AppStore from '@/store/vuex/aplicacao/AppStore';
import { FindProdutoUseCase } from '@/usecases';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({ components: {
	SeletorDeFornecedor,
	SeletorDeLojas,
	SeletorDeProdutosAgrupados,
} })
export default class TelaDeManutencaoDeProdutosDePara extends Vue {
	filtroFornecedor: number | string = '';
	filtroLoja: number | string = '';
	busca = '';

	editandoId: number | null = null;
	editandoRegistro: Partial<ProdutoDoFornecedor> = {};

	modalAberto = false;
	novoRegistro: Partial<ProdutoDoFornecedor> = {};
	erros: Record<string, string> = {};

	modalExclusaoAberto = false;
	registroParaExcluir: any | null = null;
	lojaSelecionada: Loja | null = null;
	lojas: Loja[] = [] 
	fornecedores: Fornecedor[] = [];
	produtos: ProdutoBase[] = [];
	registros: ProdutoDoFornecedor[] = [];
	fornecedorSelecionado: Fornecedor | null = null
	salvarNovoRelacionamento = false
	campoComErro = false
    mensagemErro = ''
	loading = false
	loadingSalvar = false

	findProdutoUseCase = new FindProdutoUseCase()

	get registrosFiltrados() {
		return this.registros.filter(r => {
			const matchFornecedor = !this.filtroFornecedor || r.fornecedorId === this.filtroFornecedor;
			const matchLoja = !this.filtroLoja || r.lojaId === this.filtroLoja;
			return matchFornecedor && matchLoja;
		});
	}

	getNomeFornecedor(registro) {
		return registro.fornecedor ? registro.fornecedor.razaoSocialOuNome : '-';
	}

	getNomeLoja(registro) {
		return registro.loja ? registro.loja.nome : '-';
	}

	getNomeProduto(registro) {
		const nome = registro.produto ? registro.produto.nome : '-';

		if (!nome || nome === '-') return nome;

		return nome.length > 30
			? nome.substring(0, 28) + '...'
			: nome;
	}

	getNomeProdutoCompleto(registro) {
		return registro.produto ? registro.produto.nome : '-';
	}

	iniciarEdicao(registro: ProdutoDoFornecedor) {
		this.editandoId = registro.id;
		this.editandoRegistro = { ...registro };
		this.$nextTick(() => {
			const input = this.$refs.inputCodigo as HTMLInputElement;
			if (input) input.focus();
		});
	}

	cancelarEdicao() {
		this.editandoId = null;
		this.editandoRegistro = {};
	}

	async salvarEdicao() {
		if (!this.editandoRegistro.codigoFornecedor?.trim()) {
			AlertModule.setError('O código do fornecedor é obrigatório.');
			return;
		}
		if (!this.editandoRegistro.produtoRelacionado) {
			AlertModule.setError('Selecione um produto relacionado.');
			return;
		}

		if(!this.lojaSelecionada) {
			AlertModule.setError('Não foi possivel capturar dados da Loja');
			return;
		}

		if(!this.fornecedorSelecionado) {
			AlertModule.setError('Não foi possivel capturar dados do Fornecedor');
			return;
		}

		try{

			this.loadingSalvar = true

			const idx = this.registros.findIndex(r => r.id === this.editandoId);
			if (idx >= 0) {
				this.$set(this.registros, idx, { ...this.registros[idx], ...this.editandoRegistro });
			}

			const lojaId = this.lojaSelecionada && typeof this.lojaSelecionada === 'object'
				? this.lojaSelecionada.id
				: this.lojaSelecionada;

			await this.findProdutoUseCase.editarRelacionamentoDeProdutos(this.editandoRegistro.codigoFornecedor, this.editandoRegistro.produtoRelacionado.id, this.fornecedorSelecionado.id, lojaId, this.registrosFiltrados[idx].codigo);
			
			const resultado = await this.findProdutoUseCase.findProdutoFornecedores(
				lojaId,
				this.fornecedorSelecionado.id,
				this.editandoRegistro.codigoFornecedor,
				{},
			);

			this.registros = resultado.content;
		}
		catch(e){
			AlertModule.setError(e);
			this.loadingSalvar = false
			return
		}finally{
			this.editandoId = null;
			this.editandoRegistro = {};
			AlertModule.setSuccess('Registro atualizado com sucesso!');
			this.loadingSalvar = false
		}
	}

	abrirModalAdicionar() {
		this.novoRegistro = {};
		this.erros = {};
		this.lojaSelecionada = null;
		this.fornecedorSelecionado = null
		this.modalAberto = true;
		this.busca = ''
	}

	fecharModal() {
		this.modalAberto = false;
		this.novoRegistro = {};
		this.erros = {};
	}

	async adicionarRegistro() {
		if(!this.novoRegistro.codigoFornecedor) return AlertModule.setError('Necessario Preencher o Código do Fornecedor');
		if(!this.novoRegistro.produtoRelacionado) return AlertModule.setError('Necessario Selecionar um Produto Para Relacionar');
		if(!this.fornecedorSelecionado) return AlertModule.setError('Necessario Selecionar um Fornecedor');
		if(!this.lojaSelecionada) return AlertModule.setError('Necessario selecionar uma Loja');

		try{
			this.salvarNovoRelacionamento = true

			const lojaId = this.lojaSelecionada && typeof this.lojaSelecionada === 'object'
				? this.lojaSelecionada.id
				: this.lojaSelecionada;

			await this.findProdutoUseCase.salvarRelacionamentoDeProdutos(this.novoRegistro.codigoFornecedor, this.novoRegistro.produtoRelacionado.id, this.fornecedorSelecionado.id, lojaId);
		}catch(e){
			AlertModule.setError('Erro ao adicionar relacionamento: ' + e);
			this.salvarNovoRelacionamento = false
			return
		}finally{
			this.salvarNovoRelacionamento = false;
			this.novoRegistro.codigoFornecedor = '';
			this.novoRegistro.produtoRelacionado = null;
			this.modalAberto = false;
			this.buscar()
			AlertModule.setSuccess('Relação Criada Com Sucesso!')
		}
	}

	confirmarExclusao(registro) {
		this.registroParaExcluir = registro;
		this.modalExclusaoAberto = true;
	}

	fecharModalExclusao() {
		this.modalExclusaoAberto = false;
	}

	async excluirRegistro() {
		if (!this.registroParaExcluir) return;
		if (!this.lojaSelecionada) return;
		if (!this.fornecedorSelecionado) return;

		const lojaId = this.lojaSelecionada && typeof this.lojaSelecionada === 'object'
			? this.lojaSelecionada.id
			: this.lojaSelecionada;

		try{
			await this.findProdutoUseCase.excluirRelacionamentoDeProdutos(this.registroParaExcluir.codigo, this.registroParaExcluir.produto.id, this.fornecedorSelecionado.id, lojaId);
		} catch(e){
			AlertModule.setError(e);
		} finally{
			this.registros = this.registros.filter(r => r.id !== this.registroParaExcluir?.codigo);
			this.fecharModalExclusao();
			AlertModule.setSuccess('Registro excluído com sucesso');
		}
	}

	async buscar() {
		if (!this.lojaSelecionada) return AlertModule.setError('Necessario Selecionar uma Loja');
		if (!this.fornecedorSelecionado) return AlertModule.setError('Necessario Selecionar um Fornecedor');
		if (this.busca === '') return AlertModule.setError('Necessario digitar o código do produto!');

		try {

			this.loading = true

			const lojaId = this.lojaSelecionada && typeof this.lojaSelecionada === 'object'
				? this.lojaSelecionada.id
				: this.lojaSelecionada;

			const resultado = await this.findProdutoUseCase.findProdutoFornecedores(
				lojaId,
				this.fornecedorSelecionado.id,
				this.busca,
				{},
			);

			this.registros = resultado.content;

			if (this.registros.length === 0) {
				this.campoComErro = true
				this.mensagemErro = 'Nenhum Produto Encontrado'
			}else{
				this.campoComErro = false
				this.mensagemErro = ''
			}

			this.loading = false
		} catch (e) {
			AlertModule.setError('Erro ao buscar produtos.');
			this.loading = false
		}
	}

	get modoNoturno() {
		return AppStore.modoNoturno
	}

	limpar(){
		this.lojaSelecionada = null
		this.fornecedorSelecionado = null
		this.busca = ''
	}
}
